import React from 'react';
import Services from './Services';

function ServicePage() {
    return ( 
        <>
        <Services/>
        </>
     );
}

export default ServicePage;